
import byKeyMaker from 'reducersMakers/byKeyMaker';
import articles from './articles/reducer';
import forumThreads from './forumThreads/reducer';

export default byKeyMaker('categoryType', {
  articles,
  forumThreads
});



/** WEBPACK FOOTER **
 ** ./src/members/state/categories/categorySelection/reducer.js
 **/